import React from 'react';

import { Image } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

import { FullScreenModal } from 'components/shared/FullScreenModal/FullScreenModal';
import { CreateWorker } from 'components/CreateWorker/CreateWorker';

import './style.scss';

export const Registration = () => {
    const {t} = useTranslation();

    return (
        <FullScreenModal close={false}>
            <div className="Registration__logoDiv">
                <Image src="/assets/images/DSP-Logo.svg" className="Registration__logo"/>
            </div>
            <h1 className="FullScreenModal__title">
                {t('common.individualRegistration', 'Individual Registration')}
            </h1>
            <div className="Registration__description">
                <p className="Registration__description-text text-center">
                    <Trans i18nKey="individualRegistration.description">
                        Register here to create a Disability Skills Passport Profile for yourself. If your company has
                        already registered as a provider, you can ask your company representative to create a profile
                        for you.
                    </Trans>
                </p>
            </div>
            <CreateWorker/>
        </FullScreenModal>
    );
};
